import * as React from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { parse } from "qs";
import { AuthDialogComponent } from "../../modules/auth/auth-dialog.component";
import { setIsAuthDialogOpen } from "../../modules/auth/auth.slice";
import "@inveert/ui-kit/src/grid/grid-row";
import "@inveert/ui-kit/src/grid/grid-col";
import styles from "../../styles/Auth.module.css";

function Login() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = location.search.substring(1);
  const { activeForm } = parse(params);
  React.useEffect(() => {
    dispatch(setIsAuthDialogOpen(false));
  }, []);
  return (
    <div className={styles.container}>
      <inv-grid-row style={{ justifyContent: "center" }}>
        <inv-grid-col class="col-12">
          <AuthDialogComponent
            activeForm={
              activeForm === "verification" ? "verification" : "login"
            }
          />
        </inv-grid-col>
      </inv-grid-row>
    </div>
  );
}

Login.title = "Login";
Login.layout = "EmptyLayout";
Login.mobileLayout = "MobileEmptyLayout";
export default Login;
